export default "__VITE_ASSET__c1078de4__"